// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_ph-0";
export var discountCodeInput = "_ph-1";